module.exports = __webpack_public_path__ + "img/Download-Preview2.97cfd8e7.png";